import { createSlice } from "@reduxjs/toolkit";
import { createApi } from "../../utils/api";
import { saveParameterConfigurationOverride } from "../../common/endpoints";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const saveParameterOverride = createApi(
  saveParameterConfigurationOverride,
  "POST"
);

const parameterOverrideSlice = createSlice({
  name: "parameterOverride",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(saveParameterOverride.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveParameterOverride.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(saveParameterOverride.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default parameterOverrideSlice.reducer;
